import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexKnowledgebase',
  setup(__props) {

const KnowledgebaseSearch = defineAsyncComponent(() => import("@/components/theme/knowledgebase/KnowledgebaseSearch.vue"))
const FaqWidgets = defineAsyncComponent(() => import("@/components/theme/knowledgebase/FaqWidgets.vue"))
const BrowseArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/BrowseArticles.vue"))
const FeaturesFaq = defineAsyncComponent(() => import("@/components/theme/knowledgebase/FeaturesFaq.vue"))
const LatestArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/LatestArticles.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(KnowledgebaseSearch)),
      _createVNode(_unref(FaqWidgets)),
      _createVNode(_unref(BrowseArticles)),
      _createVNode(_unref(FeaturesFaq)),
      _createVNode(_unref(LatestArticles))
    ])
  ]))
}
}

})